import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { ajaxconfig } from "../ajaxconfig";
import { VerifyPublicCbtPassCode } from "../serverurl";

const JoinTestModal = ({ isOpen, onClose }) => {
    const [cbtpasscode, setcbtpasscode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const config = ajaxconfig();

    const verify_cbt_data_pass_code = async (e) => {
        e.preventDefault();
        if (!cbtpasscode.trim()) {
            toast.error("Please enter a test passcode");
            return;
        }

        setIsLoading(true);
        const cbt_verify_data = { cbt_data_id: cbtpasscode.toUpperCase() }

        try {
            const response = await axios.post(VerifyPublicCbtPassCode, cbt_verify_data, config);
            toast.success(response.data.message);
            if (response.data.serverstatus === 200) {
                navigate(`/participate/verification?cbt_pass_code=${cbtpasscode.toUpperCase()}`);
                onClose();
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Invalid passcode. Please check and try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto animate-fade-in">
            <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div 
                    className="fixed inset-0 transition-opacity duration-300 ease-in-out" 
                    aria-hidden="true"
                    onClick={onClose}
                >
                    <div className="absolute inset-0 bg-gray-600 opacity-75 backdrop-blur-sm"></div>
                </div>

                <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full animate-scale-in">
                    {/* Modal Header */}
                    <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                                <h3 className="text-lg font-bold text-white">
                                    Join Test Session
                                </h3>
                            </div>
                            <button
                                onClick={onClose}
                                className="text-white hover:text-blue-200 transition-colors duration-200"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Modal Body */}
                    <div className="bg-white px-6 pt-6 pb-4">
                        <div className="mb-6">
                            <div className="bg-blue-50 rounded-xl p-4 border border-blue-200 mb-4">
                                <div className="flex items-start">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <div>
                                        <p className="text-sm font-medium text-blue-800">How to join a test</p>
                                        <p className="text-xs text-blue-600 mt-1">
                                            Enter the unique passcode provided by your instructor to access your test session.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <form onSubmit={verify_cbt_data_pass_code}>
                                <div className="mb-6">
                                    <label htmlFor="passcode" className="block text-sm font-semibold text-gray-700 mb-2">
                                        Test Passcode
                                    </label>
                                    <div className="relative group">
                                        <input
                                            id="passcode"
                                            type="text"
                                            value={cbtpasscode}
                                            onChange={(e) => setcbtpasscode(e.target.value)}
                                            disabled={isLoading}
                                            className="w-full px-4 py-3 pl-11 border-2 border-gray-200 rounded-xl transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 group-hover:border-blue-300 font-mono placeholder-gray-400"
                                            placeholder="Enter test passcode"
                                            required
                                            autoFocus
                                        />
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                        </svg>
                                    </div>
                                    <p className="text-xs text-gray-500 mt-2 flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-yellow-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                        Passcodes are case-insensitive and provided by your instructor
                                    </p>
                                </div>

                                <button
                                    type="submit"
                                    disabled={isLoading || !cbtpasscode.trim()}
                                    className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-3 px-4 rounded-xl shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                                >
                                    {isLoading ? (
                                        <div className="flex items-center justify-center">
                                            <svg className="animate-spin h-4 w-4 text-white mr-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            <span>Verifying Passcode...</span>
                                        </div>
                                    ) : (
                                        <div className="flex items-center justify-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            <span>Join Test Session</span>
                                        </div>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes scaleIn {
                    from { 
                        opacity: 0;
                        transform: scale(0.9) translateY(-10px);
                    }
                    to { 
                        opacity: 1;
                        transform: scale(1) translateY(0);
                    }
                }
                .animate-fade-in {
                    animation: fadeIn 0.3s ease-out;
                }
                .animate-scale-in {
                    animation: scaleIn 0.3s ease-out;
                }
            `}</style>
        </div>
    );
};

export default JoinTestModal;